import { Tooltip } from './Tooltip.styled';

export default Tooltip;
